import { useEffect, useState } from 'react';
import { API_URL } from '../config';
import { requestWriteAccess } from '../telegram/webapp';

interface Preferences {
  ownTrades: boolean;
  graduations: boolean;
  whaleTrades: boolean;
  channelEvents: boolean;
}

const labels: Record<keyof Preferences, string> = {
  ownTrades: 'Мои покупки и продажи',
  graduations: 'Градуации отслеживаемых токенов',
  whaleTrades: 'Крупные сделки',
  channelEvents: 'Запуск и градуация моих токенов',
};

export function NotificationSettingsScreen({ token }: { token: string | null }) {
  const [value, setValue] = useState<Preferences | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    if (!token) return;
    void request<Preferences>('GET', token).then(setValue).catch((e) => setError(String(e)));
  }, [token]);

  if (!token) return <div className="banner warn">Откройте настройки из Telegram.</div>;
  if (!value) return <p className="hint">{error ?? 'Загружаем настройки…'}</p>;
  return (
    <div className="scroll">
      <div className="section-label">Уведомления</div>
      <div className="group">
        {(Object.keys(labels) as Array<keyof Preferences>).map((key) => (
          <label className="cell" key={key}>
            <span className="label">{labels[key]}</span>
            <input type="checkbox" disabled={saving} checked={value[key]} onChange={(event) => {
              const next = { ...value, [key]: event.target.checked };
              setSaving(true); setError(null);
              void (async () => {
                const canWrite = next[key] ? await requestWriteAccess() : undefined;
                setValue(await request<Preferences>('PUT', token, { ...next, ...(canWrite ? { canWrite: true } : {}) }));
                if (next[key] && !canWrite) setError('Чтобы получать сообщения, откройте личный чат с ботом и нажмите «Начать».');
              })().catch(() => setError('Не удалось сохранить настройки. Попробуйте ещё раз.')).finally(() => setSaving(false));
            }} />
          </label>
        ))}
      </div>
      <p className="hint">По умолчанию включены только события ваших собственных сделок.</p>
      {error ? <div className="banner warn">{error}</div> : null}
    </div>
  );
}

async function request<T>(method: 'GET' | 'PUT', token: string, body?: unknown): Promise<T> {
  const response = await fetch(`${API_URL.replace(/\/$/, '')}/api/notification-preferences`, {
    method, headers: { authorization: `Bearer ${token}`, ...(body ? { 'content-type': 'application/json' } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  const value = await response.json() as T & { error?: string };
  if (!response.ok) throw new Error(value.error ?? `API ${response.status}`);
  return value;
}
